import { TaskManageService } from './task-manage.service';

export default angular
  .module('sfMobile.services.task-manage', ['sfMobile.services.tasks'])
  .service('taskManageService', TaskManageService).name;
